import React from 'react'

export const TwitterIcon: React.FC = () => (
  <svg width="24" height="24">
    <path
      fill="#9A8B88"
      d="M12.167.075C5.639.075.347 5.368.347 11.895c0 6.528 5.292 11.82 11.82 11.82 6.528 0 11.82-5.292 11.82-11.82 0-6.527-5.292-11.82-11.82-11.82zm5.954 9.437c.006.128.009.256.009.386 0 3.936-2.997 8.474-8.475 8.474a8.437 8.437 0 01-4.567-1.337c.234.027.47.041.71.041a5.974 5.974 0 003.7-1.275 2.982 2.982 0 01-2.782-2.07 2.945 2.945 0 001.345-.05 2.981 2.981 0 01-2.39-2.92v-.039c.402.223.861.357 1.35.373a2.977 2.977 0 01-.922-3.977 8.458 8.458 0 006.14 3.112 2.978 2.978 0 015.076-2.717 5.956 5.956 0 001.891-.723 2.987 2.987 0 01-1.31 1.648 5.948 5.948 0 001.711-.469 6.007 6.007 0 01-1.486 1.543z"
    />
  </svg>
)
